<template>
  <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
</template>
